import BeerSlider from 'beerslider';

new BeerSlider(document.getElementById('image-changer'), {
    // start value
    start: '50',
    // prefix
    prefix: 'beer'
});
